import { ActionReducerMap } from '@ngrx/store';
import { ChatActionsUnion, ChatActionTypes } from './chat.actions';
import {
  ChatState,
  Components,
  ChatStates,
  AnimationStates,
} from './chat.interfaces';

export const CHAT_FEATURE_KEY = 'omni-chat';

export const initialState: ChatState = {
  history: [],
  chatState: 'closed',
  mute: true,
  direction: 'right',
};

export function history(
  state = initialState.history,
  action: ChatActionsUnion,
): Components[] {
  switch (action.type) {
    case ChatActionTypes.Back:
      return state.length > 1 ? state.slice(0, state.length - 1) : [];

    case ChatActionTypes.GoHome:
    case ChatActionTypes.HeaderClose:
      return [];

    case ChatActionTypes.OpenDialog:
      return state.length && state[state.length - 1] === 'dialog'
        ? state
        : [...state, 'dialog'];

    case ChatActionTypes.OpenHistory:
      return [...state, 'history'];

    default:
      return state;
  }
}

export function chatState(
  state = initialState.chatState,
  action: ChatActionsUnion,
): ChatStates {
  switch (action.type) {
    case ChatActionTypes.AutoMaximize:
    case ChatActionTypes.ChatBubbleOpen:
    case ChatActionTypes.OpenDialog:
    case ChatActionTypes.HeaderMaximize:
      return 'open';

    case ChatActionTypes.HeaderClose:
      return 'closed';

    case ChatActionTypes.HeaderMinimize:
      return 'minimized';

    default:
      return state;
  }
}

export function muteState(state = true, action: ChatActionsUnion): boolean {
  return action.type === ChatActionTypes.ToggleMuteState ? !state : state;
}

export function direction(
  state = initialState.direction,
  action: ChatActionsUnion,
): AnimationStates {
  switch (action.type) {
    case ChatActionTypes.GoHome:
    case ChatActionTypes.Back:
      return state === 'left' ? 'left2' : 'left';

    case ChatActionTypes.OpenDialog:
    case ChatActionTypes.OpenHistory:
      return state === 'right' ? 'right2' : 'right';

    default:
      return state;
  }
}

export const chatReducers: ActionReducerMap<ChatState> = {
  history,
  direction,
  mute: muteState,
  chatState,
};
